import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

export type FormMode = 'create' | 'edit' | 'useModel' | 'import';

export function useFormMode(): {
  currentMode: import('vue').ComputedRef<FormMode>;
  changeMode: (newMode: FormMode) => Promise<void>;
} {
  const route = useRoute();
  const router = useRouter();

  // Le mode actuel basé sur l'URL
  const currentMode = computed<FormMode>(() => {
    return (route.query.mode as FormMode) || 'create';
  });

  // Fonction pour changer le mode
  const changeMode = async (newMode: FormMode): Promise<void> => {
    // On remplace l'historique au lieu de pousser une nouvelle entrée
    await router.replace({
      path: route.path,
      query: { ...route.query, mode: newMode }
    });
  };

  // Development helper - uncomment for debugging
  // watch(() => currentMode.value, (newMode, oldMode) => {
  //   console.log('useFormMode - Mode changé de', oldMode, 'à', newMode);
  // });

  return {
    currentMode,
    changeMode
  };
} 